import { render } from "./B2bPagePartiesServices.vue?vue&type=template&id=e4c7b1e8&scoped=true&lang=pug"
import script from "./B2bPagePartiesServices.vue?vue&type=script&lang=js"
export * from "./B2bPagePartiesServices.vue?vue&type=script&lang=js"

import "./B2bPagePartiesServices.vue?vue&type=style&index=0&id=e4c7b1e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c7b1e8"]])

export default __exports__